import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import RightToLeft from "../../../../components/transitions/right-to-left";
import { Header } from "../../../../components/header";
import { Iconfont } from "../../../../components/icon/iconfont";
import { BigButton } from "../../../../components/button";
import { useCallback } from "react";
import OrderRecommend from "../../pages/order/detail/fragments/order-recommend";
import { useHistory } from "react-router-dom";
import ReactDOM from 'react-dom'

/**
{   
	commonData:{
		templateStr:`<div style='text-align: center;'> \t<img src='https://image.geeko.ltd/chicme/2021111101/right_icon.png' alt='ModalPoints' \tstyle='width:54px;'> \t<p style='font-weight:bold;font-size:18px;margin: 0;line-height:28px;color: #000000;'> \t\t<span> \t\t\tOrder Confirmed Successfully! \t\t</span> \t</p> \t<p style='margin: 0;font-size: 12px;font-family: Roboto-Regular;line-height:16px;'> \t\tYou’ve got \t\t<span style='color: #e64545;font-weight: bold;font-family: Roboto-Regular;'> \t\t\t70 points \t\t</span> \t\tin your account. \t</p> \t<p style='margin: 0;font-size: 12px;'> \t\t<span> \t\t\t100 points = 1 USD. \t\t</span> \t\t<a href='https://www.chicme.xyz/policy/bonus-point' style='vertical-align: middle;'> \t\t\t<img src='https://image.geeko.ltd/chicme/2021111101/question.png' alt='Question' \t\t\tstyle='width: 14px;height: 14px;'> \t\t</a> \t</p> </div>`,
		orderId:orderDetail?.id,
		showHeader:false
	},
	detailReminder:{
		headerTitle:Intl.formatMessage({ id: "order_confirmed", defaultMessage: "Order Confirmed" }),
		title: Intl.formatMessage({ id: "order_confirm_success", defaultMessage: "Order Confirmed Successfully!" }),
		font: Intl.formatMessage({ id: "order_detail_view", defaultMessage: "You can view order details to check this order." }),
		btns:[
			{
				name: Intl.formatMessage({ id: "view_order", defaultMessage: "View Order" }),
				href: `/user/order/detail/${orderDetail?.id}`
			},
			{
				name: Intl.formatMessage({ id: "to_review", defaultMessage: "To Review" }),
				href: '/user/order/confirmed'
			}
		]
	}
}
 */


const SuccessReminder = props =>{
	const { reminderData, onClose } = props;
	const { commonData, detailReminder } = reminderData || {};
	const { templateStr, orderId, showHeader } = commonData  || {};
	const { title, font, btns, headerTitle } = detailReminder  || {};
	const history = useHistory();

	const handleClick = useCallback((data) =>{
		if(!data?.type){
			if(data.isReplace){
				history.replace(data?.href);
			}else{
				history.push(data?.href);
			}
			
			onClose();
		}else{
			window.location.href = data?.href;
			onClose();
		}
	}, []);

	const handleClose = useCallback(() =>{
		// history.goBack();
		onClose();
	}, []);

    return <div className={cls.SuccessReminder}>
		{
			showHeader && !templateStr && <Header centerSlot={headerTitle} onClose={handleClose} />
		}
		
        <div className={cls.ReminderContainer}>
			{
				templateStr ? <React.Fragment>
					<div dangerouslySetInnerHTML={{ __html: templateStr }}></div>
				</React.Fragment> : <React.Fragment>
					<div className={cls.SuccessIcon}>
						<Iconfont>&#xe6b7;</Iconfont>
					</div>

					{
						title && <p className={cls.Title}>{title}</p>
					}
					
					{
						font && <p className={cls.Font}>{font}</p>
					}
					
				</React.Fragment>
			}

			<div className={cls.BtnContainer}>
				{
					btns?.map((btn, index) =>(<BigButton key={index} onClick={() =>handleClick(btn)}>{btn?.name}</BigButton>))
				}
			</div>
		</div>
		
		{
			orderId && <OrderRecommend orderId={orderId} />
		}
    </div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show } = props;

	return <React.Fragment>
		<RightToLeft in={show} className={cls.SuccessReminderModal}>
			<div>
                <SuccessReminder {...props} />
			</div>
		</RightToLeft>
	</React.Fragment>
}

export default props =>{
    if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}